import React from 'react'
import './PropertyRentCompT5.scss'
import PropTypes from 'prop-types'
import {
  PropertyImage,
  PropertyInfo,
  DonutChartT2
} from '@components/custom'
import { connect } from 'react-redux'
import Comps from '@engine/comps'
import { PageTitleBar } from '@components/common'

export class PropertyRentCompT5 extends React.Component {

  render() {
    const {
      propertyType,
      toggleSettings,
      templateName,
      themeColors,
      propertyNameList,
      donutChartThemeColors,
      compsWithSubjectProperty
    } = this.props
    const {
      propertyData,
      chartData,
      signedUrl
    } = this.props.propertyInfoData
    const { hasBranding, hasPageTitle, hasDonut } = toggleSettings
    let pageTitleElement = null
    let dividerLineElement = null
    let pageDividerElement = null
    const defaultPageTitleElement = (
      <div className="title">
        <PageTitleBar templateName={templateName} hasPageTitle={hasPageTitle} hasBranding={hasBranding} themeColors={themeColors} />
      </div>
    )
    const defaultDividerLineElement = (
      <>
        <div className="vertical-divider"></div>
        <div className={(hasPageTitle || hasBranding) ? 'maint5__horizontal-dividerT5' : 'no-margin__horizontal-dividerT5'}></div>
      </>
    )
    const defaultPageDividerElement = <div className="page-dividerT5"></div>
    if (propertyData && compsWithSubjectProperty) {
      if (propertyType.toString().includes('S')) {
        pageTitleElement = defaultPageTitleElement
        dividerLineElement = defaultDividerLineElement
      } else if (Number(propertyType) % 4 === 0) {
        pageTitleElement = defaultPageTitleElement
        dividerLineElement = defaultDividerLineElement
      }
    } else if (propertyData && Number(propertyType) % 4 === 1) {
        pageTitleElement = defaultPageTitleElement
        dividerLineElement = defaultDividerLineElement
    }

    if (compsWithSubjectProperty) {
      if (Number(propertyType) % 4 === 3) {
        pageDividerElement = defaultPageDividerElement
      }
    } else if (Number(propertyType) % 4 === 0) {
      pageDividerElement = defaultPageDividerElement
    }

    return (
      <>
        <div
          className="maint5"
          id={`#property_${propertyType}`}
          data-testid={`property-rent-comps-T5-${propertyType}`}
        >
          {pageTitleElement}
          <div className={(hasPageTitle || hasBranding) ? 'maint5__property-container-t5' : 'no-margin__property-container-t5'}>

            <div className="property-container-left">
              {propertyData && <>
                <div className="property-image-plus-info">
                  <PropertyImage
                    propertyType={propertyType}
                    imageUrl={signedUrl || ''}
                    templateName={templateName}
                  />
                </div>
                <div className="donut-chart">
                  {hasDonut && <DonutChartT2
                    chartData={chartData}
                    donutChartThemeColors={donutChartThemeColors}
                    noHeader={true}
                    propertyType={propertyType}
                    themeColors={themeColors}
                  />}
                </div>
              </>
              }
            </div>
            <div className="property-container-right">
              {propertyData && <>
                <div className="info">
                  <PropertyInfo
                    propertyInfo={propertyData}
                    propertyType={propertyType}
                    templateName={templateName}
                    propertyNameList={propertyNameList}
                  />
                </div>
              </>}
            </div>
          </div>
          {dividerLineElement}
        </div>
        {pageDividerElement}
      </>
    )
  }
}

PropertyRentCompT5.propTypes = {
  donutChartThemeColors: PropTypes.object,
  amenitiesCount: PropTypes.number,
  editFeature: PropTypes.func,
  toggleSettings: PropTypes.shape({
    templateType: PropTypes.string,
    hasBranding: PropTypes.bool,
    hasDonut: PropTypes.bool,
    hasSourceNotes: PropTypes.bool,
    hasNotes: PropTypes.bool,
    hasPageTitle: PropTypes.bool,
    hasAmenities: PropTypes.bool
  }),
  templateName: PropTypes.string,
  propertyType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  propertyInfoData: PropTypes.shape({
    propertyData: PropTypes.object,
    chartData: PropTypes.shape({
      '1 Bedroom / 1 Bath': PropTypes.number,
      '2 Bedroom / 1 Bath': PropTypes.number,
      '2 Bedroom / 2 Bath': PropTypes.number,
      '3 Bedroom / 3 Bath': PropTypes.number
    }),
    signedUrl: PropTypes.string
  }),
  propertyNameList: PropTypes.array,
  themeColors: PropTypes.object,
  compsWithSubjectProperty: PropTypes.bool
}

const mapStateToProps = state => ({
  templateDataLimits: Comps.selectors.comps.templateDataLimits(state),
  templateName: Comps.selectors.comps.templateName(state),
  themeColors: Comps.selectors.comps.themeColors(state),
  compsWithSubjectProperty: Comps.selectors.comps.compsWithSubjectProperty(state)
})

export default connect(mapStateToProps)(PropertyRentCompT5)

